import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { block, unblock } from './BlockDisplayModule';
import { request } from './ApiModule';
import AuthenticationUtil from '../util/AuthenticationUtil';
import {
    COMMUNITY_FAQ_PATH,
    COMMUNITY_NOTICE_PATH,
    COMMUNITY_QNA_PATH,
    COM_PROPERTIES_KEY,
    MAIN_PATH,
    PATH_DELIMITER,
    SUBJECT_SEARCH_BODY_PATH,
} from '../constant/Constant';
import NullCheckUtil from '../util/NullCheckUtil';
import SessionStorageUtil from '../util/SessionStorageUtil';

const NoMovePath = [SUBJECT_SEARCH_BODY_PATH, COMMUNITY_NOTICE_PATH, COMMUNITY_FAQ_PATH, COMMUNITY_QNA_PATH];

const BASE = 'app';
const ACTION_GET_CONFIG = BASE + PATH_DELIMITER + 'ACTION_GET_CONFIG';
const ACTION_GET_CODES = BASE + PATH_DELIMITER + 'ACTION_GET_CODES';
const ACTION_GET_CURRENT_SEMESTER = BASE + PATH_DELIMITER + 'ACTION_GET_CURRENT_SEMESTER';

export const actionGetConfig = createAction(ACTION_GET_CONFIG);
export const actionGetCodes = createAction(ACTION_GET_CODES);
export const actionGetCurrentSemester = createAction(ACTION_GET_CURRENT_SEMESTER);

export function* appSagas() {
    yield takeEvery(ACTION_GET_CONFIG, actionGetConfigSaga);
    yield takeEvery(ACTION_GET_CODES, actionGetCodesSaga);
    yield takeEvery(ACTION_GET_CURRENT_SEMESTER, actionGetCurrentSemesterSaga);
}

function* actionGetConfigSaga({}) {
    yield put(block());
    try {
        const result = yield call(request, {
            method: 'get',
            url: '/config.json',
        });
        if (NullCheckUtil.isNotNull(result)) {
            SessionStorageUtil.setConfig(result);
        }
    } finally {
        yield put(unblock());
    }
}

function* actionGetCodesSaga({}) {
    yield put(block());
    try {
        const result = yield call(request, {
            method: 'get',
            url: '/api/code/all',
        });
        if (NullCheckUtil.isNotNull(result)) {
            SessionStorageUtil.setCode(result);
        }
    } finally {
        yield put(unblock());
    }
}

function* actionGetCurrentSemesterSaga({}) {
    yield put(block());
    try {
        const result = yield call(request, {
            method: 'get',
            url: `/api/com-prop/keys/${COM_PROPERTIES_KEY.CURRENT_SEMESTER}`,
        });
        if (NullCheckUtil.isNotNull(result)) {
            SessionStorageUtil.setCurrentSemester(result);
        }
    } finally {
        yield put(unblock());
    }
}
